import { Platform } from "react-native";

/**
 * True when the app is running in a mobile browser (Expo web on phone/tablet).
 * Used to enable camera barcode scanning only on mobile web, not desktop.
 */
export function isMobileWeb() {
  if (Platform.OS !== "web" || typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent || "";
  const mobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const coarsePointer =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(pointer: coarse)").matches;
  const narrowViewport = typeof window !== "undefined" && window.innerWidth <= 900;
  return mobileUa || coarsePointer || narrowViewport;
}
